/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
*  Copyright 2016 Adobe Systems Incorporated
*  All Rights Reserved.
*
* NOTICE:  All information contained herein is, and remains
* the property of Adobe Systems Incorporated and its suppliers,
* if any.  The intellectual and technical concepts contained
* herein are proprietary to Adobe Systems Incorporated and its
* suppliers and are protected by all applicable intellectual property laws,
* including trade secret and or copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe Systems Incorporated.
**************************************************************************/
/*jslint node:true, nomen:true, maxlen:120 */
/*global define, window */
'use strict';

/**
 * Define AdobeDC within a UMD wrapper to work with AMD, CommonJS, or globals.
 * Review build-browser.js for related changes if updating the UMD wrapper code.
 * See umdjs/umd at github for UMD wrapper samples.
 */
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(['url-template'], factory);
    } else if (typeof module === 'object' && module.exports &&
            typeof global === 'object' && global.process) {
        // CommonJS-like environments that support module.exports, like Node.
        // The check for global.module avoids problems with CommonJS Compiler.
        module.exports = factory(require('url-template'));
    } else {
        // Browser globals (root is window)
        root.AdobeDC = factory(root.urltemplate);
    }
}(typeof window === 'object' ? window : global, function (urltemplate) {

    // Now actually define and return AdobeDC inside the UMD wrapper.
    var AdobeDC = require('./src/adobe-dc'),
        methods = require('./web/adobe-dc-browser');
    AdobeDC.uritemplate = urltemplate;
    Object.keys(methods).forEach(function (method) {
        AdobeDC[method] = methods[method];
    });
    AdobeDC.API = require('./src/adobe-dc-api');

    return AdobeDC;
}));
